import { Component, inject } from '@angular/core'
import { I18nSelectorComponent } from 'src/app/elements/i18n-selector/i18n-selector.component'
import { SafePipe } from 'src/app/pipes/safe.pipe'
import { RedirectorService } from 'src/app/service/redirector.service'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'app-imprint',
  standalone: true,
  imports: [
    I18nSelectorComponent,
    SafePipe,
    RouterLink,
  ],
  templateUrl: './imprint.component.html',
  styleUrl: './imprint.component.sass'
})
export class ImprintComponent {
  protected context = inject(RedirectorService).getContext()
}
